const SERVER_URL = 'https://heckathon-backend.herokuapp.com';

export default SERVER_URL;